import { useSelector } from 'react-redux'
import { ReduxActions } from './redux-actions.js'
import ReduxSelectors from './redux-selectors.js'

// useSelectorWith(f, a, b, c) === f(state, a, b, c)
const useSelectorWith = (f, ...params) => useSelector(state => f(state, ...params))

export { ReduxActions, ReduxSelectors, useSelectorWith }
